jQuery(document).ready(function($) {
  if (!$('.solution').length) {
    return;
  }

  solution($);
});

function solution($) {

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
  }

  function imageAnimation(){
    $('.solution img').each(function(){
      let $this = $(this);

      if (isInViewport($(this)[0]) && ! $(this).hasClass('isInViewport') ) {
        $(this).addClass('scrolled').addClass('isInViewport');
        window.setTimeout( function() { $this.removeClass('scrolled') }, 1000 );
      } else {
        $(this).removeClass('scrolled').removeClass('isInViewport');
      }
    });
  }

  imageAnimation();

  $(window).on('scroll', function(){
    imageAnimation();
  })
}



// WEBPACK FOOTER //
// ./scripts/blocks/solution.js